import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import createStoreAll from "store/createStoreAll";
import history from "hist";
import { IntlProvider } from "react-intl";
import { useUpdateGlobalConfiguration } from "../util/global-configuration";

import caESMessages from "../../lang/build/messages.ca-ES.json";
import deDEMessages from "../../lang/build/messages.de-DE.json";
import enCAMessages from "../../lang/build/messages.en-CA.json";
import enGBMessages from "../../lang/build/messages.en-GB.json";
import enUSMessages from "../../lang/build/messages.en-US.json";
import esESMessages from "../../lang/build/messages.es-ES.json";
import frCAMessages from "../../lang/build/messages.fr-CA.json";
import frFRMessages from "../../lang/build/messages.fr-FR.json";
import itITMessages from "../../lang/build/messages.it-IT.json";
import ptPTMessages from "../../lang/build/messages.pt-PT.json";

import caESComponents from "../../lang/build/components.ca-ES.json";
import deDEComponents from "../../lang/build/components.de-DE.json";
import enCAComponents from "../../lang/build/components.en-CA.json";
import enGBComponents from "../../lang/build/components.en-GB.json";
import enUSComponents from "../../lang/build/components.en-US.json";
import esESComponents from "../../lang/build/components.es-ES.json";
import frCAComponents from "../../lang/build/components.fr-CA.json";
import frFRComponents from "../../lang/build/components.fr-FR.json";
import itITComponents from "../../lang/build/components.it-IT.json";
import ptPTComponents from "../../lang/build/components.pt-PT.json";

import caESShared from "../../lang/build/shared.ca-ES.json";
import deDEShared from "../../lang/build/shared.de-DE.json";
import enCAShared from "../../lang/build/shared.en-CA.json";
import enGBShared from "../../lang/build/shared.en-GB.json";
import enUSShared from "../../lang/build/shared.en-US.json";
import esESShared from "../../lang/build/shared.es-ES.json";
import frCAShared from "../../lang/build/shared.fr-CA.json";
import frFRShared from "../../lang/build/shared.fr-FR.json";
import itITShared from "../../lang/build/shared.it-IT.json";
import ptPTShared from "../../lang/build/shared.pt-PT.json";

const store = createStoreAll(history);

export function TrWebProvider({ children, locale }) {
  useUpdateGlobalConfiguration({ locale });

  let messages;
  // i18n HOSER - Add new locales here before rolling them out.
  if (locale === "ca-ES") {
    messages = { ...caESMessages, ...caESComponents, ...caESShared };
  } else if (locale === "de-DE") {
    messages = { ...deDEMessages, ...deDEComponents, ...deDEShared };
  } else if (locale === "en-CA") {
    messages = { ...enCAMessages, ...enCAComponents, ...enCAShared };
  } else if (locale === "en-GB") {
    messages = { ...enGBMessages, ...enGBComponents, ...enGBShared };
  } else if (locale === "en-US") {
    messages = { ...enUSMessages, ...enUSComponents, ...enUSShared };
  } else if (locale === "es-ES") {
    messages = { ...esESMessages, ...esESComponents, ...esESShared };
  } else if (locale === "fr-CA") {
    messages = { ...frCAMessages, ...frCAComponents, ...frCAShared };
  } else if (locale === "fr-FR") {
    messages = { ...frFRMessages, ...frFRComponents, ...frFRShared };
  } else if (locale === "it-IT") {
    messages = { ...itITMessages, ...itITComponents, ...itITShared };
  } else if (locale === "pt-PT") {
    messages = { ...ptPTMessages, ...ptPTComponents, ...ptPTShared };
  } else {
    throw Error(`Unexpected locale: ${locale}`);
  }

  return (
    <ReduxProvider store={store}>
      <IntlProvider locale={locale} messages={messages} textComponent="span">
        {children}
      </IntlProvider>
    </ReduxProvider>
  );
}
